module.exports = __webpack_public_path__ + "img/eg-11-01.1456275d.jpg";